import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-16 md:pt-24 pb-8 md:pb-14 px-4 md:px-8 max-w-6xl mx-auto text-center overflow-hidden" data-id="element-78">
      <FadeIn data-id="element-79">
        <h1 className="text-2xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-3 md:mb-4 tracking-tight" data-id="element-80">
          Dejá de cocinar todas las noches. <br className="hidden md:block" data-id="element-81" />
          <span className="text-[#2D5A27]" data-id="element-82">Recuperá tu libertad</span> con el
          MÉTODO 6:30.
        </h1>
      </FadeIn>

      <FadeIn delay={0.15} data-id="element-83">
        <div className="relative max-w-xs md:max-w-md lg:max-w-lg mx-auto mb-4 md:mb-6" data-id="element-84">
          <img src="https://cdn.magicpatterns.com/uploads/sQybZHouuML8jzxhaUCqj6/A_premium_digital_202604171633.png" alt="Arquitectura del Freezer Mockup" className="relative z-10 w-full h-auto rounded-2xl shadow-xl object-cover" data-id="element-85" />
        </div>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-86">
        <h2 className="text-base md:text-2xl text-gray-600 mb-5 md:mb-8 max-w-4xl mx-auto leading-relaxed font-medium" data-id="element-87">
          Aprendé el sistema de logística culinaria para llenar tu freezer en 2
          horas y comer como en un restaurante durante los próximos 30 días.
        </h2>
      </FadeIn>

      <FadeIn delay={0.6} data-id="element-88">
        <CTAButton subtext="Un solo pago. Acceso de por vida." className="max-w-xl mx-auto" onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-89">
          SÍ, QUIERO MI ARQUITECTURA DEL FREEZER
        </CTAButton>
      </FadeIn>
    </section>;
}